/**
 * @fileoverview gRPC-Web generated client stub for witbooking.loyalty.report.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var witbooking_loyalty_customer_v1_customer_api_pb = require('../../../../witbooking/loyalty/customer/v1/customer_api_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.loyalty = {};
proto.witbooking.loyalty.report = {};
proto.witbooking.loyalty.report.v1 = require('./report_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.report.v1.ReportAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.report.v1.ReportAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest,
 *   !proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse>}
 */
const methodDescriptor_ReportAPI_GetCustomerTransactionReport = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.report.v1.ReportAPI/GetCustomerTransactionReport',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest,
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse,
  /**
   * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest,
 *   !proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse>}
 */
const methodInfo_ReportAPI_GetCustomerTransactionReport = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse,
  /**
   * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.report.v1.ReportAPIClient.prototype.getCustomerTransactionReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.report.v1.ReportAPI/GetCustomerTransactionReport',
      request,
      metadata || {},
      methodDescriptor_ReportAPI_GetCustomerTransactionReport,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.report.v1.ReportAPIPromiseClient.prototype.getCustomerTransactionReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.report.v1.ReportAPI/GetCustomerTransactionReport',
      request,
      metadata || {},
      methodDescriptor_ReportAPI_GetCustomerTransactionReport);
};


module.exports = proto.witbooking.loyalty.report.v1;

